var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ButtonList, DropdownButton, DropdownButtonContext, } from '@dixa/lib-shared-habla';
import { appActions } from 'app/app.actions';
import { useBreakpointValue } from 'utils/mediaQuery';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';
/**
 * Represents a dropdown button component that is used to access save search
 * actions
 */
export const SavedSearchButton = (_a) => {
    var { children } = _a, dropdownButtonProps = __rest(_a, ["children"]);
    const dispatch = useAppDispatch();
    const { params, savedSearch } = useAppSelector((state) => state.search);
    const isSmallScreen = useBreakpointValue({ base: true, md: false });
    const handleOpenSavedSearchListModal = () => {
        dispatch(appActions.showModal({
            modal: {
                type: 'search:savedSearch:list',
            },
        }));
    };
    const handleOpenSavedSearchFormModal = (mode) => {
        dispatch(appActions.showModal({
            modal: {
                type: 'search:savedSearch:form',
                arg: {
                    mode,
                },
            },
        }));
    };
    const hasSearchQuery = !!params.query;
    const hasFilters = params.filters.conditions.length > 0;
    return (_jsx(DropdownButton, Object.assign({}, dropdownButtonProps, { buttonProps: Object.assign({ type: 'button' }, dropdownButtonProps.buttonProps), icon: isSmallScreen ? 'bookmark' : undefined, dropdown: _jsx(DropdownButtonContext.Consumer, { children: ({ toggleDropdown }) => (_jsxs(ButtonList, { children: [_jsx(ButtonList.Item, Object.assign({ icon: savedSearch ? 'upload' : 'search-plus', isDisabled: !hasSearchQuery && !hasFilters, onClick: () => {
                            toggleDropdown();
                            handleOpenSavedSearchFormModal(savedSearch ? 'update' : 'create');
                        }, buttonProps: {
                            type: 'button',
                        } }, { children: savedSearch ? 'Update existing' : 'Save new search' })), savedSearch && (_jsxs(_Fragment, { children: [_jsx(ButtonList.Item, Object.assign({ icon: "search-plus", onClick: () => {
                                    toggleDropdown();
                                    handleOpenSavedSearchFormModal('duplicate');
                                }, buttonProps: {
                                    type: 'button',
                                } }, { children: "Save as new search" })), _jsx(ButtonList.Divider, {})] })), _jsx(ButtonList.Item, Object.assign({ icon: "redo", onClick: () => {
                            toggleDropdown();
                            handleOpenSavedSearchListModal();
                        }, buttonProps: {
                            type: 'button',
                        } }, { children: "Apply saved search" }))] })) }), "data-testid": "saved-search-dropdown" }, { children: isSmallScreen ? null : 'Saved Searches' })));
};
